

export const logoBoxSx = {
  textAlign: 'center',
  verticalAlign: 'middle',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  '& img': {
    display: 'inline-block'
  },
  '&.menu': {
    '&:hover': {
      cursor: 'pointer',
      '& img': {
        opacity: '0.7'
      }
    }
  }
};
